import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { PdcGuardService } from './pdc-guard.service';

export const canMatchPdc: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  return inject(PdcGuardService).canMatch(segments);
};
